export default __webpack_public_path__ + "static/media/download.68b955eb.svg";